module.exports = __webpack_public_path__ + "img/GAME_CATCHTHEMOLE2.7ede7238.jpg";